import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] border-t border-white/10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <span className="text-2xl font-black tracking-tighter text-white">
              Energy<span className="text-[#00D68F]">X</span>
            </span>
            <p className="text-white/60 mt-4 max-w-md text-sm leading-relaxed">
              India's premier solar asset developer. We build, own, and operate
              clean energy infrastructure so businesses can focus on growth — not
              energy bills.
            </p>
            <div className="flex gap-4 mt-6">
              {["linkedin", "twitter", "instagram"].map((social) => (
                <a
                  key={social}
                  href="#"
                  data-testid={`footer-${social}`}
                  className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/60 hover:text-[#00D68F] hover:border-[#00D68F] transition-colors text-xs uppercase font-bold"
                >
                  {social[0].toUpperCase()}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider uppercase">
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { n: "About Us", p: "/about" },
                { n: "Services", p: "/services" },
                { n: "Projects", p: "/projects" },
                { n: "Contact", p: "/contact" },
              ].map((l) => (
                <Link
                  key={l.p}
                  to={l.p}
                  className="text-white/60 text-sm hover:text-[#00D68F] transition-colors"
                >
                  {l.n}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider uppercase">
              Contact
            </h4>
            <div className="flex flex-col gap-3 text-white/60 text-sm">
              <div className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 text-[#00D68F] shrink-0" />
                Unit 71, The Executive Centre, DLF One Horizon, Golf Course
                Road, Gurugram
              </div>
              <div className="flex items-center gap-2">
                <Mail size={14} className="text-[#00D68F]" /> info@energyx.in
              </div>
              <div className="flex items-center gap-2">
                <Phone size={14} className="text-[#00D68F]" /> +91 98737 74484
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-white/40 text-xs">
          &copy; 2026 APT EnergyX Solar Pvt Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
